import { useSelector } from 'src/client/redux';
import * as staticSplashContent from './';

export const useStaticSplashContent = () => {
  const abbreviation = useSelector((state) => state.site.abbreviation.toLowerCase());
  return staticSplashContent[abbreviation];
};
